<template>
  <div class="container">
    <el-page-header @back="goBack" content="课程详情"> </el-page-header>
    <el-row :gutter="15">
      <el-col :span="18"
        ><div class="course-left">
          <div class="course-left-ppt">
            <iframe
              allowfullscreen="true"
              class="course-view"
              :src="ppt_url"
            ></iframe>
          </div>
          <div class="course-left-comment">
            <el-row>
              <el-col :span="18">
                <div class="course-left-comment-title">备课资料</div></el-col
              >
              <el-col :span="6">
                <div class="course-left-comment-title"></div
              ></el-col>
            </el-row>

            <el-row>
              <el-col :span="20">
                <div class="course-left-comment-content">
                  <el-link
                    style="margin-left: 20px"
                    @click="LookWork('6')"
                    :disabled="curriculumMaterial.lession_plan_url == ''"
                    >备课指南<i class="el-icon-document el-icon--right"></i>
                  </el-link>

                  <el-link
                    style="margin-left: 20px"
                    @click="LookWork('1')"
                    :disabled="curriculumMaterial.exampal_work_url == ''"
                    >课堂成果<i class="el-icon-video-play el-icon--right"></i>
                  </el-link>
                  <el-link
                    style="margin-left: 20px"
                    @click="LookWork('2')"
                    :disabled="curriculumMaterial.teach_template_url == ''"
                    >授课模板<i class="el-icon-help el-icon--right"></i>
                  </el-link>
                  <el-link
                    style="margin-left: 20px"
                    :disabled="curriculumMaterial.home_template_url == ''"
                    @click="LookWork('3')"
                    >作业模板<i
                      class="el-icon-picture-outline-round el-icon--right"
                    ></i>
                  </el-link>

                  <el-link
                    style="margin-left: 20px"
                    @click="LookWork('4')"
                    :disabled="curriculumMaterial.stu_note_url == ''"
                    >学生讲义<i class="el-icon-document el-icon--right"></i>
                  </el-link>

                  <el-link
                    style="margin-left: 20px"
                    @click="LookWork('5')"
                    v-if="video_url"
                    >录播课程<i class="el-icon-video-play el-icon--right"></i>
                  </el-link>

                  <el-link
                    style="margin-left: 20px"
                    v-if="other_meterial_url"
                    :disabled="!other_meterial_url"
                    @click="DownloadFile"
                    >附加资料<i class="el-icon-bottom el-icon--right"></i>
                  </el-link></div
              ></el-col>

              <el-col :span="4">
                <div class="course-left-comment-content">
                  <el-button
                    style="margin-left: 10px"
                    size="mini"
                    type="primary"
                    disabled
                    >反馈<i class="el-icon-question el-icon--right"></i
                  ></el-button></div
              ></el-col>
            </el-row>
          </div></div
      ></el-col>
      <el-col :span="6"
        ><div class="course-right">
          <div class="course-right-video">
            <el-row>
              <el-col :span="24"
                ><div class="course-right-video-title">师训视频</div></el-col
              >
            </el-row>

            <el-row>
              <el-col :span="24"
                ><div class="course-right-video-desc">
                  <video
                    id="train_video"
                    class="coursevideo"
                    :src="train_video_url"
                    controls="controls"
                    :poster="curriculumMaterial.img_url"
                  >
                    您的浏览器不支持 video 标签。
                  </video>
                </div></el-col
              >
            </el-row>
          </div>

          <div class="course-right-video1">
            <el-row>
              <el-col :span="24"
                ><div class="course-right-video1-title">课堂实录</div></el-col
              >
            </el-row>

            <el-row>
              <el-col :span="24"
                ><div class="course-right-video1-wrapper">
                  <el-row>
                    <el-col :span="24"
                      ><div class="videolist">
                        <el-row>
                          <el-col :span="24"
                            ><div class="course-right-video1-desc">
                              <video
                                id="example_video"
                                class="coursevideo1"
                                :src="exampal_video_url"
                                controls="controls"
                                :poster="curriculumMaterial.img_url"
                              >
                                您的浏览器不支持 video 标签。
                              </video>
                            </div></el-col
                          >
                        </el-row>
                      </div></el-col
                    >
                  </el-row>
                </div></el-col
              >
            </el-row>
          </div>
        </div></el-col
      >
    </el-row>

    <el-dialog
      title="学生讲义"
      :visible.sync="dialogVisible"
      width="80%"
      top="5vh"
    >
      <div>
        <iframe style="width: 100%; height: 80vh" :src="stu_note_url"></iframe>
      </div>
    </el-dialog>

    <el-dialog
      title="备课指南"
      :visible.sync="dialogVisible2"
      width="80%"
      top="5vh"
    >
      <div>
        <iframe
          style="width: 100%; height: 80vh"
          :src="lession_plan_url"
        ></iframe>
      </div>
    </el-dialog>

    <el-dialog
      title="录播课程"
      :visible.sync="dialogVisible1"
      width="840px"
      top="10vh"
      append-to-body
    >
      <el-row style="text-align: center">
        <el-col :span="24"
          ><div class="course-right-video-desc">
            <video
              id="learn_video"
              style="width: 800px"
              class="coursevideo"
              :src="video_url"
              controls="controls"
              :poster="curriculumMaterial.img_url"
            >
              您的浏览器不支持 video 标签。
            </video>
          </div></el-col
        >
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import PreviewFile from "@/config/preview-oss";
import PreviewCdnFile from "@/config/preview-cdn";

export default {
  name: "look-curriculum",

  data() {
    return {
      curriculumMaterial: {},

      dialogVisible: false,
      ppt_url: "", //课件地址
      lession_plan_url: "", //讲义地址
      train_video_url: "", //师训视频
      exampal_video_url: "", // 课堂实录
      video_url: "", //录播视频
      other_meterial_url: "", //附加资料
      stu_note_url: "", //学生讲义
      dialogVisible1: false, //录播视频开关
      dialogVisible2: false, //备课指南预览地址

      //流量计算
      cost_num: 0, //流量花费大小
      cost_num_example: 0,
      cost_num_learn: 0,
      type: "", //流量类型  1ppt 2教案 3学生讲义 4录播课视频 5师训视频 6课堂实录 必填
      preview_url: "", //预览地址
    };
  },

  watch: {
    curriculumMaterial() {
      var _that = this;

      if (!this.curriculumMaterial.educational_institution_id) {
        console.log("平台课件");
        this.ppt_url =
          this.curriculumMaterial.ppt_url +
          "?usercode=" +
          this.$store.state.user.userInfo.code;

        console.log("平台师训视频");
        console.log(this.train_video_url);
        this.train_video_url = this.curriculumMaterial.train_video_url;
        this.exampal_video_url = this.curriculumMaterial.exampal_video_url;
        this.other_meterial_url = this.curriculumMaterial.other_meterial_url;
        this.video_url = this.curriculumMaterial.video_url;

        if (this.curriculumMaterial.stu_note_url) {
          PreviewCdnFile(
            decodeURIComponent(this.curriculumMaterial.stu_note_url),
            function (res) {
              console.log("教案预览地址");
              console.log(res);
              _that.stu_note_url = res;
            }
          );
        }
      } else {
        console.log("校区课件-watch");
        //流量计算
        var size = JSON.parse(this.curriculumMaterial.ppt_url)[0].length;
        this.cost_num = parseFloat(size.substring(0, size.length - 2));
        this.preview_url = JSON.parse(this.curriculumMaterial.ppt_url)[0].url;
        this.type = "1";

        PreviewFile(_that.preview_url, function (res) {
          console.log("PPT预览地址-watch");
          console.log(res);

          if (_that.type == "1") {
            _that.ppt_url = res;
          } else if (_that.type == "3") {
            _that.stu_note_url = res;
          }
        });

        if (this.curriculumMaterial.train_video_url) {
          this.train_video_url = JSON.parse(
            this.curriculumMaterial.train_video_url
          )[0].url;
        }

        if (this.curriculumMaterial.exampal_video_url) {
          this.exampal_video_url = JSON.parse(
            this.curriculumMaterial.exampal_video_url
          )[0].url;
        }

        if (this.curriculumMaterial.video_url) {
          this.video_url = JSON.parse(this.curriculumMaterial.video_url)[0].url;
        }
      }
    },
  },

  mounted() {
    console.log("--------加载课件----------");
    console.log("Mounted");
    console.log(this.curriculumMaterial);

    this.curriculumMaterial = this.$route.params.curriculumMaterial;

    var _that = this;

    if (!this.curriculumMaterial.educational_institution_id) {
      console.log("平台课件");
      this.ppt_url =
        this.curriculumMaterial.ppt_url +
        "?usercode=" +
        this.$store.state.user.userInfo.code;

      this.train_video_url = this.curriculumMaterial.train_video_url;
      this.exampal_video_url = this.curriculumMaterial.exampal_video_url;
      this.other_meterial_url = this.curriculumMaterial.other_meterial_url;
      this.video_url = this.curriculumMaterial.video_url;

      if (this.curriculumMaterial.stu_note_url) {
        PreviewCdnFile(
          decodeURIComponent(this.curriculumMaterial.stu_note_url),
          function (res) {
            console.log("教案预览地址");
            console.log(res);
            _that.stu_note_url = res;
          }
        );
      }
    } else {
      console.log("校区课件");
      console.log(JSON.parse(this.curriculumMaterial.ppt_url)[0].url);

      var size = JSON.parse(this.curriculumMaterial.ppt_url)[0].length;
      this.cost_num = parseFloat(size.substring(0, size.length - 2));
      this.preview_url = JSON.parse(this.curriculumMaterial.ppt_url)[0].url;
      this.type = "1";

      if (this.curriculumMaterial.train_video_url) {
        this.train_video_url = JSON.parse(
          this.curriculumMaterial.train_video_url
        )[0].url;
      }

      if (this.curriculumMaterial.exampal_video_url) {
        this.exampal_video_url = JSON.parse(
          this.curriculumMaterial.exampal_video_url
        )[0].url;
      }

      if (this.curriculumMaterial.video_url) {
        this.video_url = JSON.parse(this.curriculumMaterial.video_url)[0].url;
      }
    }
  },

  created() {
    //this.dataRefreh();
    // this.dataRefreh_example();
  },
  destroyed() {
    // 在页面销毁后，清除计时器
    this.clear();
  },

  methods: {
    goBack() {
      this.$router.push({
        name: "preview-curriculum",
        query: {
          id: this.curriculumMaterial.curriculum_id,
        },
      });
    },

    LookWork(cmd) {
      console.log("查看课堂成果");

      console.log(this.curriculumMaterial);

      if (this.curriculumMaterial.subject_id == 1) {
        if (cmd == "1") {
          window.open(
            "/jrcode/show.html?mode=edit&filepath=" +
              this.curriculumMaterial.exampal_work_url
          );
        } else if (cmd == "2") {
          window.open(
            "/jrcode/show.html?mode=edit&filepath=" +
              this.curriculumMaterial.teach_template_url
          );
        } else if (cmd == "3") {
          window.open(
            "/jrcode/show.html?mode=edit&filepath=" +
              this.curriculumMaterial.home_template_url
          );
        }
      } else if (this.curriculumMaterial.subject_id == 2) {
        if (cmd == "1") {
          //完整版
          window.open(
            "/scratch/show.html?workurl=" +
              this.curriculumMaterial.exampal_work_url +
              "&workname=" +
              this.curriculumMaterial.title +
              "-课堂成果"
          );
        } else if (cmd == "2") {
          //空模板
          window.open(
            "/scratch/show.html?workurl=" +
              this.curriculumMaterial.teach_template_url +
              "&workname=" +
              this.curriculumMaterial.title +
              "-课堂模板"
          );
        } else if (cmd == "3") {
          //课后作业
          window.open(
            "/scratch/show.html?workurl=" +
              this.curriculumMaterial.home_template_url +
              "&workname=" +
              this.curriculumMaterial.title +
              "-作业模板"
          );
        }
      } else if (this.curriculumMaterial.subject_id == 3) {
        if (cmd == "1") {
          let routeData = this.$router.resolve({
            name: "python_course",
            query: { type: "1", title: this.curriculumMaterial.title },
          });
          window.open(routeData.href, "_blank");

          this.$store.commit(
            "SET_EXAM_WORK_URL",
            this.curriculumMaterial.exampal_work_url || ""
          );

          this.$store.commit(
            "SET_TEACH_TEMPLATE_URL",
            this.curriculumMaterial.teach_template_url || ""
          );
        } else if (cmd == "2" || cmd == "3") {

          console.log("PYTHON课堂空模板");
          console.log(this.curriculumMaterial.teach_template_url);



          let routeData = this.$router.resolve({
            name: "python_course",
            query: {operate:"1", type: "2", title: this.curriculumMaterial.title },
          });
          window.open(routeData.href, "_blank");
          this.$store.commit(
            "SET_HOME_TEMPLATE_URL",
            this.curriculumMaterial.home_template_url || ""
          );
          this.$store.commit(
            "SET_TEACH_TEMPLATE_URL",
            this.curriculumMaterial.teach_template_url || ""
          );
        }
      }

      if (cmd == "4") {
        console.log("观看学生讲义");
        this.dialogVisible = true;

        var size = JSON.parse(this.curriculumMaterial.stu_note_url)[0].length;
        this.cost_num = parseFloat(size.substring(0, size.length - 2));
        this.preview_url = JSON.parse(
          this.curriculumMaterial.stu_note_url
        )[0].url;
        this.type = "3";
      }

      if (cmd == "5") {
        this.dialogVisible1 = true;
      }

      if (cmd == "6") {
        this.dialogVisible2 = true;
        this.preview_url = JSON.parse(
          this.curriculumMaterial.lession_plan_url
        )[0].url;

        var _that = this;

        PreviewFile(this.preview_url, function (res) {
          console.log("校区教案预览地址-watch");
          console.log(res);
          _that.lession_plan_url = res;
        });
      }
    },

    DownloadFile() {
      console.log("下载附加资料");

      window.open(this.curriculumMaterial.other_meterial_url, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 15px;

  .course-left {
    height: calc(100vh - 111px);
    display: flex;
    flex-flow: column;
    background: white;

    .course-left-ppt {
      flex: 6;
      padding: 5px;

      .course-view {
        width: 100%;
        height: 100%;
      }
    }
    .course-left-comment {
      flex: 1;

      display: flex;
      flex-flow: column;

      .course-left-comment-title {
        padding: 10px;
        flex: 1;
        font-weight: 500;
      }
      .course-left-comment-content {
        flex: 1;
      }
    }
  }
  .course-right {
    height: calc(100vh - 111px);
    display: flex;
    flex-flow: column;
    background: white;
    .course-right-video {
      flex: 1;

      .course-right-video-title {
        padding: 10px;
        font-weight: 500;
      }
      .course-right-video-desc {
        .coursevideo {
          width: 100%;
          border: 2px solid #dee2e9;
          object-fit: fill;
        }
      }
    }
    .course-right-video1 {
      flex: 2;

      .course-right-video1-title {
        padding: 10px;
        font-weight: 500;
      }

      .course-right-video1-wrapper {
        height: calc((100vh - 81px) / 2 + 50px);
        overflow-y: scroll;
        overflow-x: hidden;
      }

      .videolist {
        padding-bottom: 10px;
      }
      .course-right-video1-desc {
        .coursevideo1 {
          width: 100%;
          border: 2px solid #dee2e9;
          object-fit: fill;
        }
      }
    }
  }
}
</style>
 